<div class="feedback-wrapper" *ngIf="_dataService.aiFeedbackRequested && !hasAiFeedback">
    <div class="feedback-subtext">
        <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
        <span>{{ 'interviews.AI Feedback processing on {date}' | translate: {date: (today | date:'MMM d, y, h:mm a')} }}</span>
    </div>
    <div>{{ 'interviews.AI Feedback Processing Content' | translate }}</div>
</div>
<div class="feedback-wrapper" *ngFor="let feedback of feedbackList">
    @if (feedback.reviewer === 'AI' && feedback.status === 'failed') {
        <div class="feedback-subtext">
            <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
            <span>{{ 'interviews.AI Feedback failed on {date}' | translate: {date: (feedback.modified | date:'MMM d, y, h:mm a')} }}</span>
        </div>
        <div>{{ 'interviews.AI Feedback Failed Content' | translate }}</div>
    } @else if (feedback.reviewer === 'AI' && ['pending', 'queued', 'started'].includes(feedback.status)) {
        <div class="feedback-subtext">
            <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
            <span>{{ 'interviews.AI Feedback processing on {date}' | translate: {date: (feedback.created | date:'MMM d, y, h:mm a')} }}</span>
        </div>
        <div>{{ 'interviews.AI Feedback Processing Content' | translate }}</div>
    } @else if (feedback.reviewer === 'AI') {
        <stars-rating [rating]="feedback.rating"></stars-rating>
        <div class="feedback-subtext">
            <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
            <span>{{ 'interviews.generated on {date}' | translate: {date: (feedback.modified | date:'MMM d, y, h:mm a')} }}</span>
        </div>
        <div class="ai-feedback" [innerHTML]="feedback.review | keepHtml"></div>
    } @else {
        <stars-rating [rating]="feedback.rating"></stars-rating>
        <div class="feedback-subtext">
            <span>{{ 'interviews.Submitted by' | translate }} </span>
            <strong>{{ feedback.reviewer }}</strong>
            <span> {{ 'interviews.on {date}' | translate: {date: (feedback.modified | date:'MMM d, y, h:mm a')} }}</span>
            <span *ngIf="feedback.created !== feedback.modified"> ({{ 'interviews.Edited' | translate }})</span>
        </div>
        <div>{{ feedback.review }}</div>
    }
</div>
